export { SelfXSS } from './SelfXSS';
